import { render, staticRenderFns } from "./ProNoOwnPrice.vue?vue&type=template&id=8c2b38d0&scoped=true"
import script from "./ProNoOwnPrice.vue?vue&type=script&lang=js"
export * from "./ProNoOwnPrice.vue?vue&type=script&lang=js"
import style0 from "./ProNoOwnPrice.vue?vue&type=style&index=0&id=8c2b38d0&prod&lang=less&scoped=true"
import style1 from "./ProNoOwnPrice.vue?vue&type=style&index=1&id=8c2b38d0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2b38d0",
  null
  
)

export default component.exports